// extracted by mini-css-extract-plugin
module.exports = {"AvatarUpload":"AvatarUpload_AvatarUpload__tmTMw","Icon":"AvatarUpload_Icon__RVC2B","Image":"AvatarUpload_Image__xzaLI"};